module.exports = __webpack_public_path__ + "img/mail.fc180df2.svg";